import { useEffect, useState, forwardRef, useCallback } from "react";

import {
  Card,
  CardContent,
  Typography,
  CardActions,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  Dialog,
  DialogActions,
  Button,
  DialogContent,
  Slide,
  DialogContentText,
  DialogTitle,
  TablePagination,
  Modal,
  Box,
  MenuItem,
  TextField,
  CircularProgress,
  CardMedia,
  Container,
  useMediaQuery,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import _ from "lodash";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useMemo } from "react-router-dom";

import ShoppingCart from "@mui/icons-material/ShoppingCart";
import CloseIcon from "@mui/icons-material/Close";
import TuneIcon from "@mui/icons-material/Tune";
import CustomLayout from "views/CustomLayout";
import CustomBreadcrumbs from "components/Breadcrumbs";
import DropdownMenu from "components/DropdownMenu";
import DynamicFilter from "containers/DynamicFilter";
import Loader from "components/Loader";
import axiosInstance from "configs/axiosConfig";
import { APIRouteConstants } from "constants/routeConstants";

import { filterCategory } from "constants/appData/filters";
import { productList } from "constants/appData/productList";
// import { handleOpenAuthDialog } from "utils/auth";
import { getAccessToken } from "utils";
import { updateCartCount } from "utils/website";
import {
  addCartItemsToLocalStorage,
  getCartCountFromLocalStorage,
  getCartFromLocalStorage,
  getCartItemsFromLocalStorage,
  getCartSummaryFromLocalStorage,
} from "utils/cart";
import { useSnackbar } from "notistack";
import { GLOBAL_CURRENCY } from "constants/appConstants";
import { ReactComponent as NoData } from "assets/svgs/NoData.svg";

import FilterDropdown from "containers/DynamicFilter/FilterDropdown";
import FlagContent from "components/InappropriateContent";
import { useAuth } from "oidc-react";
import FloatingCartBar from "views/Cart/CartFooter";
import instance from "configs/axiosConfig";
import { useFooterVisibility } from "Context/FooterContext";
import { formatCurrencyNew } from "utils/helper";
import CategoryBar from "./component/CategoryBar ";
import VariantSelector from "./component/VarientSelector";
import { useTheme } from "@mui/material/styles";
import MobileFilterDrawer from "components/drawer/MobileFilterDrawer";
// import FlagContent from "components/InappropriateContent";

// let formatCurrency = new Intl.NumberFormat(undefined, {
//   style: 'currency',
//   currency: GLOBAL_CURRENCY.code,
//   currencyDisplay: 'narrowSymbol',
//   minimumFractionDigits: 2
// });

function formatCurrency(currencyCode, currencyDisplay = "narrowSymbol") {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currencyCode ? currencyCode : GLOBAL_CURRENCY.code,
    currencyDisplay: currencyDisplay,
    minimumFractionDigits: 2,
  });
}

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const isDisabledItem = (item) => item?.is_disabled === true;

const FilterBar = ({
  selectSort,
  sorting,
  filterCategory,
  openDrawer,
  isMobileOrTab,
}) => (
  <Box
    className="filter-bar-wrapper"
    sx={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: 2,
      width: "100%",
    }}
  >
    {/* SORT */}
    <DropdownMenu
      name="Sort"
      menuList={[
        { value: "new", label: "What's New" },
        { value: "most_popular", label: "Most Popular" },
        { value: "price_low_to_high", label: "Price: Low to High" },
        { value: "price_high_to_low", label: "Price: High to Low" },
        { value: "A-Z", label: "A-Z" },
        { value: "Z-A", label: "Z-A" },
      ]}
      handleSelect={(e) => selectSort(e)}
      selectedMenu={sorting}
    />

    {/* FILTER */}
    {isMobileOrTab ? (
      <Button
        variant="outlined"
        onClick={openDrawer}
        endIcon={<TuneIcon />}
        sx={{
          fontSize: { xs: "13px", sm: "14px", md: "15px" },
          textTransform: "none",
          borderRadius: "10px",
          fontWeight: 600,
        }}
      >
        Filter
      </Button>
    ) : (
      <FilterDropdown filterCategory={filterCategory} type={"filter"} />
    )}
  </Box>
);

const ProductCard = ({
  varient_colors,
  varient_sizes,
  product,
  count,
  image,
  name,
  brand,
  price,
  handleClick,
  handleAddToCart,
  cart,
  token,
  singleVarient,
}) => {
  const currentCart = getCartItemsFromLocalStorage();
  const currentCartItem =
    currentCart && currentCart.filter((item) => item?.id === product?.id);
  const currentCartItemWithToken =
    cart && cart.filter((item) => item?.product === product?.id);

  const currentQuantity = currentCartItem?.[0]?.quantity;
  const currentQuantityWithToken = currentCartItemWithToken?.[0]?.quantity;

  const quantity = token ? currentQuantityWithToken : currentQuantity;

  const { websiteInfo } = useSelector((state) => state.webDetails);

  const [isWebsiteFunctional, setIsWebsiteFunctional] = useState(false);
  const [hasCheckedWebsiteInfo, setHasCheckedWebsiteInfo] = useState(false);

  useEffect(() => {
    if (websiteInfo) {
      setIsWebsiteFunctional(websiteInfo.status ?? false);
      setHasCheckedWebsiteInfo(true);
    }
  }, [websiteInfo]);

  const hasVariants = varient_colors?.length > 0 || varient_sizes?.length > 0;

  const hasSingleSize =
    varient_colors?.filter((item) => item.name != "")?.length === 1;
  const hasSingleColor =
    varient_sizes?.filter((item) => item.name != "")?.length === 1;
  const currentVarient = {
    ...product?.variants[0],
    product_name: product?.name,
  };

  console.log("varient_colors");
  return (
    <Card
      onClick={handleClick}
      sx={{
        width: "100%",
        height: 270,
        minHeight: 270,
        maxHeight: 270,
        borderRadius: "10px",
        border: "1px solid rgba(0,0,0,0.06)",
        boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
        overflow: "hidden",
        cursor: "pointer",
        transition: "transform 0.25s, box-shadow 0.25s",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "#fff",
        boxSizing: "border-box",
        flexShrink: 0,
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: "0px 6px 16px rgba(0,0,0,0.12)",
        },
      }}
    >
      {/* IMAGE */}
      <Box
        sx={{
          height: 130,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 1,
          background: "#f9f9f9",
          position: "relative",
        }}
      >
        <CardMedia
          component="img"
          image={image}
          alt={name}
          sx={{
            maxHeight: "110px",
            objectFit: "contain",
          }}
        />

        {!count && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background: "rgba(255,255,255,0.85)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "0.75rem",
                fontWeight: 600,
                color: "#800000",
              }}
            >
              Out of Stock
            </Typography>
          </Box>
        )}
      </Box>

      {/* CONTENT */}
      <CardContent
        sx={{
          p: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflow: "hidden",
        }}
      >
        <Box>
          {/* NAME */}
          <Typography
            sx={{
              fontSize: "0.70rem",
              color: "var(--text-muted)",
              fontWeight: 500,
              height: 32, // fixed name height
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {_.truncate(_.trim(name), { length: 20 })}
          </Typography>

          {/* BRAND */}
          <Typography
            sx={{
              fontSize: "0.70rem",
              color: "var(--text-muted)",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              mt: 0.5,
            }}
          >
            {brand}
          </Typography>

          {/* PRICE */}
          <Typography
            sx={{
              fontSize: "0.8rem",
              fontWeight: 600,
              mt: 0.5,
            }}
          >
            {formatCurrencyNew(price || 0, websiteInfo?.currency_symbol)}
          </Typography>
        </Box>
      </CardContent>

      <CardActions
        sx={{
          p: 0.8,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        {singleVarient && !hasSingleSize && !hasSingleColor && count > 0 ? (
          <Tooltip title="Add to Cart">
            <Button
              size="small"
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                handleAddToCart(currentVarient);
              }}
              disabled={
                hasCheckedWebsiteInfo &&
                (!isWebsiteFunctional || count === quantity)
              }
              sx={{
                flex: 1,
                fontSize: "0.65rem",
                minHeight: "26px",
                py: 0.2,
                px: 0.8,
                textTransform: "none",
              }}
            >
              Add
            </Button>
          </Tooltip>
        ) : (
          <Button
            size="small"
            variant="outlined"
            sx={{
              flex: 1,
              fontSize: "0.65rem",
              minHeight: "26px",
              py: 0.2,
              px: 0.8,
              textTransform: "none",
            }}
          >
            View
          </Button>
        )}

        {/* Smaller Icon */}
        <Box
          sx={{
            ml: 0.5,
            "& svg": {
              fontSize: "10px", // 🔥 smaller icon
            },
          }}
        >
          <FlagContent productName={name} product={product} />
        </Box>
      </CardActions>
    </Card>
  );
};

function queryStringToJSON(search) {
  if (!search) return {};
  var qs = search.slice(1);

  var pairs = qs.split("&");
  var result = {};
  pairs.forEach(function (p) {
    var pair = p.split("=");
    var key = pair[0];
    var value = decodeURIComponent(pair[1] || "");

    if (result[key]) {
      if (Object.prototype.toString.call(result[key]) === "[object Array]") {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      result[key] = value;
    }
  });

  return JSON.parse(JSON.stringify(result));
}

const ProductList = ({ breadcrumbs }) => {
  const { isFooterVisible, hasInitialized, setHasInitialized } =
    useFooterVisibility();
  const auth = useAuth();
  console.log("visible", auth?.userData?.expires_at);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const webDetails = useSelector((state) => state.webDetails);
  const { allCategories, refreshCart, websiteInfo } = webDetails;
  const loggedInUser = useSelector((state) => state.userDetails);
  const { doLogin, isAuthOpen } = loggedInUser;
  const [filteredCategories, setFilteredCategory] = useState([]);
  const [selectedCategory, selectCategory] = useState();
  const [allProducts, setProductList] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  // const [askLogin, openAskLogin] = useState(false);
  const queryString = useLocation();
  const query = queryStringToJSON(queryString.search);
  const [sorting, selectSort] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const { search } = query;

  const [cartCount, setCartCount] = useState(null);
  const [cart, setCart] = useState(null);
  const [subTotal, setSubTotal] = useState(null);
  const naviagte = useNavigate();
  const [hasMobileUpdateModal, setHasMobileUpdateModal] = useState(false);

  const [productList, setProductListLocal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [snackbarShown, setSnackbarShown] = useState(false);
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);
  const [qrExpiredOpen, setQrExpiredOpen] = useState(false);
  const theme = useTheme();
  const isMobileOrTab = useMediaQuery("(max-width:1024px)");

  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const fetchProductsByTableNumber = async () => {
    setLoading(true);

    let tableNumber = localStorage.getItem("number");
    if (!tableNumber) {
      console.warn("⚠️ No table number found in localStorage.");
      setProductListLocal([]);
      setMessage("");
      setLoading(false);
      return;
    }

    try {
      let res = await axiosInstance.get(
        APIRouteConstants.DASHBOARD.BULKQRSTATUS,
        {
          params: { number: tableNumber },
        },
      );

      let { data } = res;

      if (data?.recent_pending_order_present === true && !snackbarShown) {
        enqueueSnackbar(
          "For ease of ordering and billing, we recommend only one person per table to place orders.",
          { variant: "error" },
        );
        setSnackbarShown(true);
      } else {
        setMessage("");
      }

      setProductListLocal(data.results || []);
    } catch (error) {
      console.error("❌ Error fetching product list:", error);
      setProductListLocal([]);
      setMessage("");
    }

    setLoading(false);
  };

  useEffect(() => {
    const d6_token_expiry = localStorage.getItem("token-expiry");
    console.log("Token expiry from storage:", d6_token_expiry, auth);
    if (auth?.userData?.expires_at) {
      localStorage.setItem("token-expiry", auth?.userData?.expires_at);
    }
    if (d6_token_expiry) {
      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
      const expiryTime = parseInt(d6_token_expiry);
      const twentyFourHoursInSeconds = 24 * 60 * 60; // 24 hours in seconds

      // If token is already expired or expiring within 24 hours
      if (expiryTime <= currentTime + twentyFourHoursInSeconds) {
        console.log(
          "Token expired or expiring soon. Attempting silent renewal...",
        );
        auth.userManager
          .signinSilent()
          .then((user) => {
            console.log("Silent success:", user);
          })
          .catch((err) => {
            console.error("Silent failed:", err);
          });
      } else {
        console.log(
          "Token is still valid for more than 24 hours. No renewal needed.",
        );
      }
    }
  }, []);

  useEffect(() => {
    fetchProductsByTableNumber();
  }, []);
  useEffect(() => {
    setHasInitialized(true);
  }, []);

  useEffect(() => {
    const D6USERDATA = localStorage.getItem("d6_user_data");
    if (D6USERDATA == "false") {
      setHasMobileUpdateModal(true);
    }
  }, [webDetails]);

  var token = getAccessToken();

  // const filterCategory = (categories) => {
  //   // 1. Create a map of IDs for fast lookup
  //   const idMap = new Set(categories.map((cat) => cat.id));

  //   // 2. Identify root categories: either parent is null/falsy, OR parent ID is not in the list
  //   const buildTree = (parentId = null) => {
  //     return categories
  //       .filter((cat) => {
  //         if (parentId === null) {
  //           // Any item whose parent is falsy or not in the collection is a root
  //           return !cat.parent || !idMap.has(cat.parent);
  //         }
  //         return cat.parent == parentId; // Use == for type-insensitive match
  //       })
  //       .map((cat) => ({
  //         ...cat,
  //         child: buildTree(cat.id),
  //       }));
  //   };

  //   const tree = buildTree();
  //   const hasChildren = tree.some((cat) => cat.child && (cat.child.length > 0 || cat.child.length === 0));

  //   setFilteredCategory({
  //     categories: tree,
  //     type: hasChildren ? "nested" : "checkbox",
  //   });
  // };

  const filterCategory = (categories) => {
    const categoryMap = {};
    const tree = [];
    // 1️⃣ Create map of categories
    categories.forEach((cat) => {
      categoryMap[cat.id] = { ...cat, child: [] };
    });

    // 2️⃣ Build tree
    categories.forEach((cat) => {
      if (cat.parent && categoryMap[cat.parent]) {
        categoryMap[cat.parent].child.push(categoryMap[cat.id]);
      } else {
        tree.push(categoryMap[cat.id]); // root category
      }
    });
    const sorted = [...tree].sort((a, b) => {
      if (a.display_order == null) return 1; // a goes last
      if (b.display_order == null) return -1; // b goes last
      return Number(a.display_order) - Number(b.display_order);
    });

    // console.log("categories", sorted);
    // 3️⃣ Check if any category has children
    const hasChildren = sorted.some((cat) => cat.child.length > 0);

    setFilteredCategory({
      categories: sorted,
      type: hasChildren ? "nested" : "checkbox",
    });
  };
  useEffect(() => {
    if (allCategories.length > 0) {
      filterCategory(allCategories);
    }
  }, [allCategories.length]);

  const getProductList = async (category) => {
    setLoader(true);
    let queryParams = {
      page: pageCount + 1,
    };
    if (category) queryParams["category_name"] = category;
    if (sorting === "A-Z" || sorting === "Z-A") {
      queryParams["alpha_sort"] = sorting;
    } else if (sorting) {
      queryParams["sort"] = sorting;
    }
    if (search) queryParams["query"] = search;
    let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.ALL_PRODUCT, {
      params: queryParams,
    });
    let { data, response } = res;
    data = data?.results
      ? {
          ...data,
          results: data.results
            .filter((product) => !isDisabledItem(product))
            .map((product) => ({
              ...product,
              variants: Array.isArray(product?.variants)
                ? product.variants.filter((variant) => !isDisabledItem(variant))
                : product?.variants,
            }))
            .filter(
              (product) =>
                !Array.isArray(product?.variants) ||
                product.variants.length > 0,
            ),
        }
      : data;

    if (data && data.results) {
      const normalizeProduct = (item) => ({
        ...item,
        // keep original id (variant) but add normalized fields used by UI
        name: item?.product_name || item?.name,
        product_image:
          (item?.images && item.images[0]?.image) || item?.product_image,
      });
      const normalized = data.results.map(normalizeProduct);
      setProductList(normalized);
      setTotalCount(data.count);
      setPageCount(data.current_page - 1);
    }
    setLoader(false);
  };

  useEffect(() => {
    if (!_.isEmpty(query.category)) {
      selectCategory(query.category);
    }
  }, [query.category]);

  useEffect(() => {
    if (!_.isEmpty(selectedCategory)) {
      getProductList(selectedCategory);
    } else getProductList();
  }, [selectedCategory, pageCount, sorting, search]);

  const handleChangePage = (event, newPage) => {
    setPageCount(newPage);
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const addToCart = async (product) => {
    setLoader(true);
    if (!token) {
      addCartItemsToLocalStorage(product);
      getProductList(selectedCategory);
      updateCartCount(true);
      // await delay(5000);
      enqueueSnackbar(
        "Hey, this feels great! Product has been added to the cart.",
        { variant: "success" },
      );
    } else {
      let res = await axiosInstance.post(
        APIRouteConstants.DASHBOARD.ADD_TO_CART,
        {
          product_id: product.id,
        },
      );
      let { data, response } = res;

      if (response && response.status === 400 && response.data) {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, { variant: "error" });
        } else
          for (let i in response.data) {
            enqueueSnackbar(_.capitalize(i) + ": " + response.data[i][0], {
              variant: "error",
            });
          }
      }

      if (data) {
        enqueueSnackbar(
          "Hey, this feels great! Product has been added to the cart.",
          { variant: "success" },
        );
        updateCartCount(true);
      }
    }
    setLoader(false);
  };

  const getTableNumberFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("number"); // Extracts 'table-1' from '?number=table-1'
  };

  useEffect(() => {
    const tableNumber = getTableNumberFromURL();

    if (tableNumber) {
      localStorage.setItem("number", tableNumber); // Store full value (e.g., 'table-1')
      console.log("Stored Table Number:", tableNumber);
      checkQrStatus(tableNumber);
    }
  }, []);

  const checkQrStatus = async (number) => {
    try {
      // Extract only the numerical digits to pass to the API (e.g., 'room-1' -> '1')
      const numericPart = String(number).replace(/\D/g, "");
      const apiFormatNumber = numericPart || number;

      const res = await axiosInstance.get(
        APIRouteConstants.DASHBOARD.CHECKQRSTATUS(apiFormatNumber),
        { isPublic: true },
      );
      const { data, response } = res;
      // If the API returns an error status or is_valid === false, show the popup
      if (
        (response && response.status >= 400) ||
        (data && data.qr_valid === false)
      ) {
        setQrExpiredOpen(true);
        localStorage.removeItem("number");
        const params = new URLSearchParams(window.location.search);
        params.delete("number");
        const newSearch = params.toString();
        navigate(newSearch ? `?${newSearch}` : window.location.pathname, {
          replace: true,
        });
      }
    } catch (error) {
      console.error("QR status check error:", error);
      setQrExpiredOpen(true);
      localStorage.removeItem("number");
      const params = new URLSearchParams(window.location.search);
      params.delete("number");
      const newSearch = params.toString();
      navigate(newSearch ? `?${newSearch}` : window.location.pathname, {
        replace: true,
      });
    }
  };

  const getCartCount = async () => {
    if (!token) {
      let count = getCartCountFromLocalStorage();
      const subTotal = getCartFromLocalStorage();
      setCartCount(count);
      setSubTotal(subTotal);
    } else {
      let res = await instance.get(APIRouteConstants.DASHBOARD.GET_CART_ITEMS);
      let { data, response } = res;

      let count = 0;
      if (data && data.cart_items) {
        for (let i of data.cart_items) {
          count = count + i.quantity;
        }
        setCart(data.cart_items);
        setCartCount(count);
        setSubTotal(data?.subtotal_price);
      }
    }
  };
  useEffect(() => {
    getCartCount();
  }, [refreshCart]);
  const handleViewCart = useCallback(() => {
    navigate("/cart");
  }, []);
  const [isAtNinetyPercent, setIsAtNinetyPercent] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsAtNinetyPercent(hasReachedNinetyPercentScroll());
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial check

    return () => window.removeEventListener("scroll", handleScroll); // Cleanup
  }, []);

  const hasReachedNinetyPercentScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    const scrolledPercentage = (scrollTop + clientHeight) / scrollHeight;
    return scrolledPercentage >= 0.87;
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageCount]);
  return (
    <CustomLayout>
      <Loader open={loader} />
      <Box
        sx={{
          mt: {
            xs: "140px",
            sm: "90px",
            md: "90px",
          },
        }}
      >
        <CategoryBar
          allCategories={allCategories}
          handleSelect={selectCategory}
          selectedCategory={selectedCategory}
          setPageCount={setPageCount}
        />
      </Box>
      <Container
        maxWidth="lg"
        sx={{
          mt: 1,
          px: { xs: 1, sm: 2, md: 3 },
        }}
      >
        <Box
          className="catalog-wrapper content-container"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          {/* <CustomBreadcrumbs list={breadcrumbs} name="Products" /> */}
          {/* <Divider className="divider" /> */}

          <Grid
            container
            spacing={1}
            className="main-content-wrapper"
            sx={{ p: "0 !important" }}
          >
            {" "}
            {isDesktop && (
              <Grid item xs={12} sm={12} md={3} className="category-wrapper">
                {console.log(
                  "filteredCategories",
                  filteredCategories.categories,
                )}{" "}
                <DynamicFilter
                  filterCategory={[
                    {
                      title: "Categories",
                      type: filteredCategories.type,
                      items: filteredCategories.categories || [],
                      selectedItem: selectedCategory,
                      handleSelect: (category) => {
                        selectCategory(category);
                        if (
                          !_.isEmpty(query.category) &&
                          query.category != category
                        ) {
                          navigate(`/products`);
                        }
                      },
                    },
                  ]}
                />
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sm={12}
              md={isDesktop ? 9 : 12}
              className="catalog-list-wrapper"
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  mb: { xs: 1.5, sm: 2, md: 3 },
                  width: "100%",
                  px: { xs: 0.5, sm: 0 },
                }}
              >
                <FilterBar
                  totalCount={totalCount}
                  pageCount={pageCount}
                  handleChangePage={handleChangePage}
                  selectSort={selectSort}
                  sorting={sorting}
                  filterCategory={[
                    {
                      title: "Categories",
                      type: filteredCategories.type,
                      items: filteredCategories.categories || [],
                      selectedItem: selectedCategory,
                      handleSelect: (category) => {
                        selectCategory(category);
                        if (
                          !_.isEmpty(query.category) &&
                          query.category != category
                        ) {
                          navigate(`/products`);
                        }
                      },
                    },
                  ]}
                  openDrawer={() => setOpenFilterDrawer(true)}
                  isMobileOrTab={isMobileOrTab}
                />
                {/* <FilterDropdown 
                              filterCategory={[{
                                  title: "Categories",
                                  type: filteredCategories.type,
                                  items: filteredCategories.categories || [],
                                  selectedItem: selectedCategory,
                                  handleSelect: (category) => {
                                      selectCategory(category)
                                      if (!_.isEmpty(query.category) && query.category != category) {
                                          navigate(`/products`)
                                      }
                                  }
                              }]} 
                              /> */}
              </Box>
              <Grid
                container
                className="catalog-list"
                columnSpacing={{ xs: 1, sm: 1.5, md: 2 }}
                rowSpacing={{ xs: 1.5, sm: 2 }}
                alignItems="flex-start"
              >
                {allProducts.length > 0 ? (
                  allProducts.map((product, i) => {
                    const variants = product?.variants || [];
                    const totalStock = variants?.reduce((sum, item) => {
                      return sum + (item.stock_count || 0);
                    }, 0);

                    // Unique Colors
                    const groupColors = variants.reduce((acc, item) => {
                      const color = item.color;
                      if (color && !acc.some((c) => c.name === color.name)) {
                        acc.push({
                          name: color.name,
                          hex: color.hex_code,
                        });
                      }
                      return acc;
                    }, []);

                    // Unique Sizes
                    const groupSizes = variants.reduce((acc, item) => {
                      const size = item.size;
                      if (size && !acc.some((s) => s.name === size.name)) {
                        acc.push({
                          name: size.name,
                          category: size.category,
                        });
                      }
                      return acc;
                    }, []);

                    return (
                      <>
                        <Grid
                          item
                          xs={6}
                          sm={3}
                          mb={2}
                          sx={{
                            boxSizing: "border-box",
                            flexBasis: {
                              xs: "50%",
                              sm: "25%",
                              md: "20%",
                              lg: "20%",
                              xl: "20%",
                            },
                            maxWidth: {
                              xs: "50%",
                              sm: "25%",
                              md: "20%",
                              lg: "20%",
                              xl: "20%",
                            },
                            width: {
                              xs: "50%",
                              sm: "25%",
                              md: "20%",
                              lg: "20%",
                              xl: "20%",
                            },
                          }}
                        >
                          <ProductCard
                            info={webDetails}
                            token={token}
                            cart={cart}
                            product={product}
                            image={product?.product_image}
                            brand={product?.category_name}
                            name={product?.name}
                            price={
                              product.price === null ||
                              product.price === "" ||
                              variants?.length > 0
                                ? variants[0]?.price
                                : product.price
                            }
                            mrp={product.price}
                            discount={product.discount}
                            count={totalStock}
                            singleVarient={variants?.length === 1}
                            varient_colors={groupColors}
                            varient_sizes={groupSizes}
                            handleClick={() => {
                              navigate(
                                `/product/${variants[0]?.id || product?.id}`,
                              );
                            }}
                            handleAddToCart={(product) => {
                              addToCart(product);
                            }}
                          />
                        </Grid>
                        {window.location.pathname === "/products" &&
                          (!isFooterVisible ||
                            [1, 2].includes(allProducts?.length)) &&
                          hasInitialized && (
                            <FloatingCartBar
                              totalCount={totalCount}
                              cartCount={cartCount}
                              subTotal={subTotal}
                              onViewCart={handleViewCart}
                            />
                          )}
                      </>
                    );
                  })
                ) : (
                  <Grid container className="empty-wrapper">
                    <div className="icon-wrapper">
                      <NoData />
                    </div>
                    <span className="title">No Product Available</span> <br />
                    {/* <span className="description">
                                  Please add some products to your shopping cart before proceeding to checkout. 
                              </span> */}
                    <span className="description">
                      Browse our shop categories to discover new arrivals and
                      special offers.
                    </span>
                    {/* <div className='button-wrapper'>
                                  <Button variant="contained" href='/products'>
                                      RETURN TO SHOP
                                  </Button>
                              </div> */}
                  </Grid>
                )}
              </Grid>
              <Box mt={2}>
                <TablePagination
                  rowsPerPageOptions={[]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={totalCount < 10 ? totalCount : 10}
                  page={pageCount}
                  onPageChange={handleChangePage}
                  sx={{
                    "& .MuiTablePagination-actions": {
                      marginRight: 0,
                      marginLeft: "0px !important",
                    },
                    "& .MuiToolbar-root": {
                      paddingLeft: "0px !important",
                      marginLeft: "5px !important",
                    },
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
      {isMobileOrTab && (
        <Drawer
          anchor="right"
          open={openFilterDrawer}
          onClose={() => setOpenFilterDrawer(false)}
          PaperProps={{
            sx: {
              width: { xs: "100%", sm: "380px", md: "400px" },
              p: { xs: 2, sm: 3 },
            },
          }}
        >
          {/* HEADER */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              borderBottom: "1px solid rgba(0,0,0,0.12)",
              pb: 2,
            }}
          >
            <Typography sx={{ fontSize: "1rem", fontWeight: 600 }}>
              Categories
            </Typography>

            <IconButton onClick={() => setOpenFilterDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* CATEGORY LIST */}
          <List>
            {filteredCategories?.categories?.map((cat) => (
              <Box key={cat.id}>
                <ListItemButton
                  onClick={() => {
                    selectCategory(cat.name);
                    setOpenFilterDrawer(false);
                  }}
                  sx={{
                    borderRadius: "12px",
                    mb: 1,
                    backgroundColor:
                      selectedCategory === cat.name ? "#f2f2f2" : "#f7f7f7",
                  }}
                >
                  <ListItemText
                    primary={cat.name}
                    primaryTypographyProps={{
                      fontSize: { xs: "0.72rem", sm: "0.76rem", md: "0.80rem" },
                      fontWeight: "500",
                    }}
                  />
                </ListItemButton>
                {/* Render children for the drawer */}
                {cat.child && cat.child.length > 0 && (
                  <List sx={{ pl: 4 }}>
                    {cat.child.map((child) => (
                      <ListItemButton
                        key={child.id}
                        onClick={() => {
                          selectCategory(child.name);
                          setOpenFilterDrawer(false);
                        }}
                        sx={{
                          borderRadius: "12px",
                          mb: 1,
                          backgroundColor:
                            selectedCategory === child.name
                              ? "#f2f2f2"
                              : "transparent",
                        }}
                      >
                        <ListItemText
                          primary={child.name}
                          primaryTypographyProps={{
                            fontSize: {
                              xs: "0.72rem",
                              sm: "0.76rem",
                              md: "0.80rem",
                            },
                            fontWeight: "500",
                          }}
                        />
                      </ListItemButton>
                    ))}
                  </List>
                )}
              </Box>
            ))}
          </List>

          <Divider sx={{ mt: 2, mb: 2 }} />

          {/* FOOTER BUTTONS */}
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              backgroundColor: "#fff",
              pt: 2,
              pb: 2,
              display: "flex",
              gap: 2,
            }}
          >
            <Button
              fullWidth
              variant="outlined"
              sx={{
                textTransform: "none",
                borderRadius: "10px",
                fontWeight: 600,
              }}
              onClick={() => {
                selectCategory(null);
                setOpenFilterDrawer(false);
              }}
            >
              Clear
            </Button>

            <Button
              fullWidth
              variant="contained"
              sx={{
                textTransform: "none",
                borderRadius: "10px",
                fontWeight: 600,
              }}
              onClick={() => setOpenFilterDrawer(false)}
            >
              Show results
            </Button>
          </Box>
        </Drawer>
      )}

      <D6UpdateMobileModal
        isDialogOpen={hasMobileUpdateModal}
        setDialogOpen={setHasMobileUpdateModal}
      />

      {/* QR Expired Dialog */}
      <Dialog
        open={qrExpiredOpen}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="qr-expired-dialog-title"
        aria-describedby="qr-expired-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            p: 1,
            maxWidth: "380px",
            width: "90%",
            boxShadow: "0px 8px 32px rgba(0,0,0,0.18)",
          },
        }}
      >
        <DialogTitle
          id="qr-expired-dialog-title"
          sx={{
            fontWeight: 700,
            fontSize: "1rem",
            color: "#c0392b",
            pb: 0,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          ⚠️ QR Code Expired
        </DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <DialogContentText
            id="qr-expired-dialog-description"
            sx={{ fontSize: "0.85rem", color: "text.primary", lineHeight: 1.6 }}
          >
            QR code has expired. Please contact admin or visit:{" "}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.location.reload();
              }}
              style={{
                color: "#1976d2",
                fontWeight: 600,
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              {websiteInfo?.store_name || "the store"}
            </a>
          </DialogContentText>
        </DialogContent>
        {/* <DialogActions sx={{ px: 2, pb: 2 }}>
          <Button
            onClick={() => setQrExpiredOpen(false)}
            variant="outlined"
            color="error"
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              fontWeight: 600,
              px: 3,
            }}
          >
            Cancel
          </Button>
        </DialogActions> */}
      </Dialog>
    </CustomLayout>
  );
};

const D6UpdateMobileModal = ({ isDialogOpen, setDialogOpen }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("27"); // Default country code
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");
  const handleUpdate = async () => {
    if (!mobileNumber) {
      setError("Mobile number is required.");
      return;
    }
    if (mobileNumber.length < 9 || mobileNumber.length > 15) {
      setError("Enter a valid mobile number (9 to 15 digits).");
      return;
    }
    const token = localStorage.getItem("u-access-token");
    setLoading(true);
    try {
      const response = await axiosInstance.put(
        APIRouteConstants.AUTH.D6_UPDATE_PHONE,
        {
          mobile_number: mobileNumber,
          country_code: countryCode,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data) {
        localStorage.setItem("d6_user_data", JSON.stringify(true));
        setError("");
        setDialogOpen(false);
        // Navigate or take further actions on success
        window.location.reload();
      }
    } catch (error) {
      console.error("Error updating mobile number:", error);
      setError("Failed to update the mobile number. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Modal open={isDialogOpen}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "80%", sm: "75%", md: "50%", lg: "40%" },
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
          }}
        >
          {/* Header Section */}
          <Grid container alignItems="center" spacing={0} sx={{ mb: 4 }}>
            <Typography variant="body1" textAlign="left" sx={{ width: "100%" }}>
              Please update your mobile number (mandatory)!
            </Typography>
          </Grid>

          {/* Modal Content */}
          <Grid container direction="column" alignItems="center">
            {/* Country Code Dropdown and Mobile Number Input */}
            <Grid item xs={12} sx={{ width: "100%", mb: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    select
                    fullWidth
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                    label="Country Code"
                  >
                    <MenuItem value="27">27 (SA)</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    fullWidth
                    size="small"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    label="Mobile Number"
                    type="tel"
                    error={!!error}
                    helperText={error}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12} sx={{ width: "100%", mt: 2 }}>
              <Button
                variant="contained"
                fullWidth
                onClick={handleUpdate}
                sx={{ textTransform: "none" }}
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={24} />
                ) : (
                  "Update Mobile Number"
                )}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default ProductList;
